// Reads downloads/manifest.json — same-origin static file served by Nginx
// (see compose.yaml's ./downloads mount), never the API. Optional: the
// APK link works without it, this is only for showing version/size.
export interface ApkManifest {
  versionName: string;
  versionCode: number;
  file: string;
  sha256: string;
  sizeBytes: number;
  publishedAt: string;
}

export async function getApkManifest(): Promise<ApkManifest | null> {
  try {
    const res = await fetch("/downloads/manifest.json", { cache: "no-store" });
    if (!res.ok) return null;
    return (await res.json()) as ApkManifest;
  } catch {
    return null;
  }
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
